import classNames from "classnames";
import * as React from "react";

import styles from "./DataTable.module.css";

interface DataTableToolbarProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Horizontal toolbar slot for `DataTable.Root`. Hosts the filter button and
 * any future controls (column visibility, density, export). Lays children
 * out in a flex row with consistent gap; consumers wrap it in their own
 * div if they need additional alignment.
 *
 * @example
 * ```tsx
 * <DataTable.Root>
 *   <DataTable.Toolbar>
 *     <DataTable.Filters filterDefinitions={fields} />
 *   </DataTable.Toolbar>
 *   <DataTable.Table {...tableState.table} ... />
 * </DataTable.Root>
 * ```
 */
export function DataTableToolbar({
  children,
  className,
}: DataTableToolbarProps) {
  return (
    <div className={classNames(styles.toolbar, className)}>{children}</div>
  );
}
